<template>
  <img v-if="map[$query.tag]" v-img-pop="{name: $query.tag}" :src="map[$query.tag]">
  <div v-else>(敬请期待)</div>
</template>
<script>

export default {
  data () {
    // noinspection NonAsciiCharacters
    return {
      map: {},
    }
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 900px;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ComingSoon.vue